import { SOCKET_EVENTS } from "./Socket";

let allUsers = [];
let organisedUsersMap = {};
// isNaN(Number("key")) === false

/**
 * 
 * @param {*} socketUsers // socket users Stored in Socket.js
 * @param {*} socektMe //current user 
 * @returns map of users ordered by scenes
 */
export const organiseUsersByLocation = (socketUsers, socketMe) => {
  // {
  //   userId: '2',
  //   userName: 'vlado',
  //   userAvatarUrl: 'http://localhost:8921/img/defaultAvatars/avatar1.png',
  //   currentSceneId: '0cad2bcb-9ecc-40ca-b173-c1311d6d36c2',
  //   currentSceneName: 'SCENE 1 - 1 - 1',
  //   creatorUserIdOfWorld: '1',
  //   currentUserMood: 1,
  //   userVideoOn: false,
  //   userScreenShareOn: false,
  //   audioLevels: 0,
  //   hasProfile: '2',
  //   url: 'http://localhost:8921/index.php?r=worlds%2Fview&id=1'
  // }
  organisedUsersMap = {};
  allUsers = [];
  Object.keys(socketUsers).forEach(key => {
    const user = socketUsers[key];
    if (socketUsers[key] && socketUsers[key].userId) {
      if (socketUsers[key].userId && user.currentSceneId) {
        if (user.userId === socketMe.userId)
          return;
        allUsers.push(user);
        if (!organisedUsersMap[user.currentSceneId]) {
          organisedUsersMap[user.currentSceneId] = [];
        }
        organisedUsersMap[user.currentSceneId].push(user);
      }
    }
  });
  return organisedUsersMap;
};

export const getOrganisedUsers = () => {
  return organisedUsersMap;
}

export const getUsersFromOtherScenes = (exludedCurrentSceneId) => {
  return allUsers.filter(item => item.currentSceneId !== exludedCurrentSceneId);
}

export const autoGenerateUsersList = (model, socket) => {
  // socket.addEventListener(SOCKET_EVENTS.USER_DATA_CHANGED, () => {
  //   // organiseUsersByLocation(socket.getUsers());
  //   console.log(getOrganisedUsers());
  // })
}

/**
 * 
 * @returns array of all users
 *  should be called after organiseUsersByLocation
 */
export const getAllUsers = () => {
  return allUsers
}
